/**
 * Tooltip.js
 * A basic script that applies a mouseover tooltip functionality to all elements of a page that have a data-tooltip attribute
 * Matthias Schuetz, http://matthiasschuetz.com
 *
 * Copyright (C) Matthias Schuetz
 * Free to use under the MIT license
 * 
 * Been modified a little:
 * 		1) Removed use of 'data-tooltip' as a selector to find instances.
 *		2) Overall simplification. Removed features we don't need
 *		3) Changed it so this runs on "DOMContentLoaded" instead of "load" event. This causes it to run earlier and as a result shows a tooltip earlier.
 *		4) Fixed positioning so it does not fall off the sreen. The X position is to the left or right edge of the cursor, unless the screen is too narrow, then we center the tooltip and set a max width.
 */

var tooltipsSelector = "hasTooltip";
var tooltipId = "tooltip";
var _tooltips: any[] = [];

export default function init() {
	var tooltipElems = document.getElementsByClassName(tooltipsSelector);
	for (var idx = 0; idx < tooltipElems.length; idx++) {
		var elm = tooltipElems[idx];
		var tooltipText = elm.getAttribute("title").trim();

		if (tooltipText) {
			elm.setAttribute("title", "");
			elm.setAttribute("data-tooltip-id", idx.toString());
			
			_tooltips[idx] = {
				text: tooltipText
			};

			elm.addEventListener("mousemove", _onElementMouseMove);
			elm.addEventListener("mouseout", _onElementMouseOut);
			elm.addEventListener("mouseover", _onElementMouseOver);
		}
	}
}

function _createTooltip(text: string) {
	var tooltipElm = document.createElement("div");
	var tooltipText = document.createTextNode(text);

	tooltipElm.setAttribute("id", tooltipId);
	tooltipElm.appendChild(tooltipText);

	document.querySelector("body").appendChild(tooltipElm);
}

function _getTooltipElm() {
	return document.getElementById(tooltipId);
}

function _onElementMouseMove(evt: MouseEvent) {
	var tooltipElm = _getTooltipElm();
	var offset = 15;
	var scrollY = window.scrollY || window.pageYOffset;
	var scrollX = window.scrollX || window.pageXOffset;
	var tooltipTop = evt.pageY + offset;
	var tooltipLeft = evt.pageX + offset;
	var gutter = 20;

	if (tooltipElm) {
		if (tooltipTop - scrollY + tooltipElm.offsetHeight + gutter >= document.documentElement.clientHeight) {
			tooltipTop = tooltipTop - tooltipElm.offsetHeight - gutter;
		}

		if (tooltipElm.offsetWidth >= document.documentElement.clientWidth / 2) {
			tooltipLeft = evt.pageX - (tooltipElm.offsetWidth / 2);
			tooltipLeft = Math.max(gutter, tooltipLeft);
			tooltipElm.style.maxWidth = (document.documentElement.clientWidth - (gutter * 2)) + "px";
		} else {
			if (tooltipLeft - scrollX + tooltipElm.offsetWidth + 20 >= document.documentElement.clientWidth) {
				if (tooltipLeft > tooltipElm.offsetWidth) {
					tooltipLeft = tooltipLeft - tooltipElm.offsetWidth - 20;
				}
				tooltipElm.style.maxWidth = null;
			}
		}
		

		tooltipElm.style.top = tooltipTop + "px";
		tooltipElm.style.left = tooltipLeft + "px";
	}
}

function _onElementMouseOut(evt: MouseEvent) {
	var tooltipElm = _getTooltipElm();

	if (tooltipElm) {
		document.querySelector("body").removeChild(tooltipElm);
	}
}

function _onElementMouseOver(evt: MouseEvent) {
	var tooltipId = this.getAttribute("data-tooltip-id");
	var tooltipText = tooltipId && _tooltips[tooltipId] && _tooltips[tooltipId].text;

	if (tooltipText) {
		_createTooltip(tooltipText);	
	}
}